export default function PageLoading() {
  return (
    <div className="flex min-h-[60vh] w-full items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-background-700 border-t-primary-500" />
    </div>
  );
}